import moment from 'moment';
import {preference} from './localStorage';

export const utc = (date, format = 'YYYY-MM-DDTHH:mm:ss') => moment(date).subtract(moment.tz(preference.get().timezone || 'UTC')._offset, 'minutes').format(format);

export const toUtc = (date) => utc(date, 'YYYY-MM-DD HH:mm:ss');
export const toUtcDate = (date) => utc(date, 'YYYY-MM-DD');

export const getDisplayDate = (date, options = {returnMills: false, format: 'YYYY-MM-DD HH:mm:ss'}) => {
  let {returnMills, format} = options,
    // timeZoneName = preference.get().timezone || moment.tz.guess(),
    timeZoneName = preference.get().timezone || 'UTC',
    utcOffset = moment.tz(timeZoneName)._offset,
    sample_time =  moment.utc(date).valueOf(),
    sample_time_zone = moment.utc(date)._tzm * 60000 || 0,
    local_time_zone_offset = utcOffset * 60000,

    display_time_mills = sample_time - sample_time_zone + local_time_zone_offset;

  if(returnMills) return display_time_mills;
  return moment.utc(sample_time - sample_time_zone + local_time_zone_offset).format(format)
};

export const timezones = [
  { offset: '-12:00' },
  { offset: '-11:00' },
  { offset: '-10:00' },
  { offset: '-09:30' },
  { offset: '-09:00' },
  { offset: '-08:00' },
  { offset: '-07:00' },
  { offset: '-06:00' },
  { offset: '-05:00' },
  { offset: '-04:00' },
  { offset: '-03:30' },
  { offset: '-03:00' },
  { offset: '-02:00' },
  { offset: '-01:00' },
  { offset: '+00:00' },
  { offset: '+01:00' },
  { offset: '+02:00' },
  { offset: '+03:00' },
  { offset: '+03:30' },
  { offset: '+04:00' },
  { offset: '+04:30' },
  { offset: '+05:00' },
  { offset: '+05:30' },
  { offset: '+05:45' },
  { offset: '+06:00' },
  { offset: '+06:30' },
  { offset: '+07:00' },
  { offset: '+08:00' },
  { offset: '+08:30' },
  { offset: '+08:45' },
  { offset: '+09:00' },
  { offset: '+09:30' },
  { offset: '+10:00' },
  { offset: '+10:30' },
  { offset: '+11:00' },
  { offset: '+12:00' },
  { offset: '+12:45' },
  { offset: '+13:00' },
  { offset: '+14:00' },
];



// WEBPACK FOOTER //
// ./src/libs/date.js